import React from 'react'
import { StrikethroughPrice } from '@moonpig/web-core-types-graphql'
import { Box, Text } from '@moonpig/launchpad-components'
import { LogoPlusPillInverted } from '@moonpig/launchpad-assets'

export const StrikethroughPriceDisplay = ({
  member,
  original,
}: StrikethroughPrice) => {
  return (
    <Box display={'flex'} gap={8} alignItems={'center'}>
      <s>
        <Text typography="typeBodyText">{original.display}</Text>
      </s>
      <Text typography="typeBodyLabel" color="colorFeedbackSuccess">
        {member.display}
      </Text>
      <LogoPlusPillInverted width={50} />
    </Box>
  )
}
